import { useEffect } from 'react'
import Container from '@mui/material/Container'
import { useTranslation } from 'react-i18next'
import HelmetMeta from '../../layouts/HelmetMeta.js'

export default function Cookies () {
  const { t } = useTranslation('legals')

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Container>
      <HelmetMeta
        {...{
        title: t('cookies.metaTitle'),
        description: t('cookies.metaDescription'),
        image: '/img/races/i/ramadan-race.jpg'
      }}
      />
      <div>
        <br /><br /><br /><br />
        <h1>{t('cookies.heading')}</h1>
        <p>
          {t('cookies.p1Before')}
          <a style={{ color: 'orange' }} href='https://www.peakssports.com' target='_blank' rel='noreferrer'>peakssport.com</a>
          {t('cookies.p1After')}
        </p>
        <p>
          {t('cookies.p2Before')}
          <a style={{ color: 'orange' }} href='https://www.peakssports.com' target='_blank' rel='noreferrer'>peakssports.com</a>
          {t('cookies.p2After')}
        </p>
        <h2>{t('cookies.whatHeading')}</h2>
        <p>{t('cookies.whatP1')}</p>
        <p>{t('cookies.whatP2')}</p>
        <p>{t('cookies.whatP3')}</p>
        <br />
        <h2>{t('cookies.typesHeading')}</h2>
        <br />
        <h3>{t('cookies.essentialHeading')}</h3>
        <p>{t('cookies.essentialP')}</p>
        <h3>{t('cookies.performanceHeading')}</h3>
        <p>{t('cookies.performanceP')}</p>
        <h3>{t('cookies.functionalityHeading')}</h3>
        <p>{t('cookies.functionalityP')}</p>
        <h3>{t('cookies.targetingHeading')}</h3>
        <p>{t('cookies.targetingP')}</p>
        <h2>{t('cookies.thirdPartyHeading')}</h2>
        <p>{t('cookies.thirdPartyP')}</p>
        <h3>{t('cookies.promiseHeading')}</h3>
        <p>{t('cookies.promiseP')}</p>
        <br />
        <h2>{t('cookies.controlHeading')}</h2>
        <p>{t('cookies.controlP1')}</p>
        <p>{t('cookies.controlP2')}</p>
        <p>{t('cookies.controlP3')}</p>
      </div>
    </Container>
  )
}
